const INTRO_POINTS = [
  {
    label: "Public accounts only",
    desc: "Reads what's already visible - no login to their account, no notifications.",
  },
  {
    label: "Tracked over time",
    desc: "Followers, unfollows, follows, likes and post performance at regular intervals.",
  },
  {
    label: "Summarized for you",
    desc: "Growth, churn, and engagement rolled into readable AI activity reports.",
  },
] as const;

export default function PeeqdActivityTrackerIntro() {
  return (
    <section
      aria-labelledby="activity-tracker-intro"
      className="-mx-4 mt-10 border-y border-line/80 bg-surface sm:-mx-6 lg:-mx-10"
    >
      <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 sm:py-14 lg:px-10">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-16">
          <div className="lg:pt-1">
            <p className="mb-3 text-xs font-semibold uppercase tracking-widest text-rose-deep">
              Activity tracking
            </p>
            <h2
              id="activity-tracker-intro"
              className="font-display text-2xl font-extrabold tracking-tight text-ink sm:text-[1.75rem]"
            >
              What is an Instagram activity tracker?
            </h2>
          </div>

          <div className="border-l border-line pl-6 sm:pl-8 lg:pl-10">
            <p className="text-sm leading-relaxed text-muted sm:text-[15px]">
              A tool that watches a public account from the outside and turns follower changes,
              likes, and post performance into reports you can actually read.
            </p>
            <ul className="mt-5 space-y-3.5">
              {INTRO_POINTS.map((point) => (
                <li key={point.label} className="text-sm leading-relaxed sm:text-[15px]">
                  <span className="font-semibold text-ink">{point.label}.</span>{" "}
                  <span className="text-muted">{point.desc}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
